import { defineComponent } from 'vue';
import Title from './title.vue';
import img1 from '@/assets/images/index/steps-01.png';
import img2 from '@/assets/images/index/steps-02.png';
import img3 from '@/assets/images/index/steps-03.png';
import img4 from '@/assets/images/index/steps-04.png';
export default defineComponent({
  name: 'steps',
  data() {
    return {
      currentType: 0,
      list: [{
        title: 'Describe <br>Your Idea',
        img: img1,
        subtitle: 'Enter a description or upload a photo of your pet.'
      }, {
        title: 'Choose Your <br>Model Style',
        img: img2,
        imgs: 'https://cdn-static.dupdub.com/frontend/meishe/4a9ce874-642b-49d9-98a4-219b18a65389/gif/1737343106590.gif',
        subtitle: 'Select from a variety of color styles to suit your vision'
      }, {
        title: 'Preview <br>and Adjust',
        img: img3,
        imgs: 'https://cdn-static.dupdub.com/frontend/meishe/2e31ac3f-a980-4db9-97c2-e65c3bb9f103/gif/1737343313108.gif',
        subtitle: 'View your 3D model in real-time and make any tweaks.'
      }, {
        title: 'Submit <br>for Printing',
        img: img4,
        imgs: 'https://cdn-static.dupdub.com/frontend/meishe/405cccbf-0d2f-45ef-a618-d71370ae780b/gif/1737343395907.gif',
        subtitle: 'Generate the file and send your printing request.'
      }],
      typeList: [{
        title: 'Describe <br>Your Idea'
      }, {
        title: 'Choose Your <br>Model Style'
      }, {
        title: 'Preview <br>and Adjust'
      }, {
        title: 'Submit <br>for Printing'
      }]
    };
  },
  components: {
    Title
  },
  mounted() {
    // 监听滚动
    window.addEventListener('scroll', this.handleActive, true);
    this.handleActive();
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleActive);
  },
  methods: {
    changeType(index) {
      const box = this.$refs[`box${index}`];
      box[0].scrollIntoView({
        behavior: 'smooth' // 平滑滚动效果
      });
    },
    handleActive() {
      let active = 0;
      this.typeList.forEach((item, index) => {
        var _el$;
        const el = this.$refs[`box${index}`];
        const rect = (_el$ = el[0]) === null || _el$ === void 0 ? void 0 : _el$.getBoundingClientRect();
        if (rect && this.isTopHalf(rect)) active = index;
      });
      this.currentType = active;
    },
    isTopHalf(rect) {
      const {
        top = 0
      } = rect;
      return top <= 50 + 114 + 300;
    }
  }
});